export default class SearchDropdown {

    constructor() {
        
        this.settings = {
            $searchIcon : $('.js-search-icon'),
            $searchDropdown : $('.js-search-dropdown-reveal')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$searchIcon != null ) {
            const $searchDropdown = this.settings.$searchDropdown;

            this.settings.$searchIcon.on('click',  () => {
                $(document).ready(function() {
                    const headerMainHeight = $('header.header').height();
                    const headerTopHeight = $('.js-header-usp').outerHeight();
                    const headerHeight = headerMainHeight + headerTopHeight;
                    $searchDropdown.toggleClass('scale-y-0 max-h-0');
                    $searchDropdown.css({'height': 'calc(100vh - ' +headerHeight + 'px)', 'overflow-y': 'auto'});
                });
            });

            $('.js-search-close').on('click',  () => {
                $searchDropdown.toggleClass('scale-y-0 max-h-0');
            });
        }

    }

};

new SearchDropdown();